<template>
  <div>
    <v-card color="grey lighten-5" flat>
      <v-form>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{baslik}}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn v-if="this.$route.query.islem == 'yeni'" @click="ekle()" class="white--text" flat><span
                  class="hidden-sm-and-down">Kaydet </span>
                <v-icon right dark>add_box</v-icon>
              </v-btn>
              <v-btn v-if="this.$route.query.islem == 'guncelle'" @click="guncelle()" class="white--text" flat><span
                  class="hidden-sm-and-down">Güncelle </span>
                <v-icon right dark>add_box</v-icon>
              </v-btn>
              <v-menu bottom="">
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list v-if="this.$route.query.islem == 'yeni'">
                  <a target="_self" v-bind:href="'#/destek/index/'">
                    <v-list-tile>
                      <v-list-tile-title>{{$t('cancel_button')}}</v-list-tile-title>
                    </v-list-tile>
                  </a>
                </v-list>
                  <v-list v-if="this.$route.query.islem == 'guncelle'">
                  <a target="_self" v-bind:href="'#/destek/sorundetay/id?' + 'sorunid=' + this.$route.query.sorunid">
                    <v-list-tile>
                      <v-list-tile-title>{{$t('cancel_button')}}</v-list-tile-title>
                    </v-list-tile>
                  </a>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>
          <v-layout row="" wrap="">
            <v-flex pa-1 xs12 sm12 md12>
              <v-card class="white--text">
                <v-card color="grey lighten-4" flat="">
                  <v-card-actions>
                    <v-form ref="formmusteri" lazy-validation>
                      <v-layout justify-space-between column>
                        <v-layout row wrap>
                          <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                          <v-flex xs12 sm4 md4>
                            <v-autocomplete :items="itemsUrun" v-model="SorunEkle.UrunBilgi.Ref" item-text="UrunAdi"
                              item-value="Ref" label="Ürün Adı" max-height="400"></v-autocomplete>
                          </v-flex>
                          <v-flex xs12 sm4 md4>
                               <v-autocomplete hide-details="" :items="itemsUserBilgi"
                              v-model="SorunEkle.CozecekBilgi.UserID" item-text="AdSoyad" item-value="UserID" clearable
                              label="Çözecek"></v-autocomplete>
                          </v-flex>
                            <v-flex xs12 sm2 md3>
                            <tarihim :etiket="'Alış Tarihi'" :detaygizle="false" v-model="SorunEkle.AlisTarihi"
                              v-bind:defaultvalue="'ok'" :rules="[v => !!v || 'Lütfen tarih seçiniz']"></tarihim>
                          </v-flex>
                           <v-flex  xs12 sm2 md1>
                            <v-checkbox  v-model="SorunEkle.UcretliDestek" label="Ücretli Destek"></v-checkbox>
                          </v-flex> 
                          </v-layout>
                          </v-flex>
                             <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                                <v-flex xs12 sm4 md4>
                            <v-autocomplete :items="itemsBekledigiYer" v-model="SorunEkle.BeklenenYer.Id"
                              item-text="Aciklama" item-value="Id" label="İşin Beklediği Yer" max-height="400">
                            </v-autocomplete>
                          </v-flex>
                       <v-flex xs12 sm4 md4>
                            <v-text-field hide-details="" v-model="SorunEkle.Arayan" label="Arayan"></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm2 md3>
                            <v-text-field v-model="SorunEkle.BaslangicSaat" label="Başlangıç Saati" append-outer-icon="access_time">
                              </v-text-field>
                          </v-flex>
                            <v-flex xs12 sm2 md1>
                            <v-checkbox v-model="SorunEkle.Cozuldu" label="Çözüldü"></v-checkbox>
                          </v-flex>
                          </v-layout>
                          </v-flex>
                             <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs12 sm4 md4>
                            <v-autocomplete :items="itemsSorunTip" v-model="SorunEkle.SorunTip.SorunTipID"
                              label="Sorun Türü" item-value="SorunTipID" item-text="Aciklama"></v-autocomplete>
                          </v-flex>
                             <v-flex xs12 sm4 md4>
                            <v-text-field hide-details="" v-model="SorunEkle.ArayanMail" label="Arayan Mail">
                            </v-text-field>
                          </v-flex> 
                          <v-flex xs12 sm2 md3>
                            <v-text-field v-model="SorunEkle.BitisSaat" label="Bitiş Saati"  append-outer-icon="access_time">
                            </v-text-field>
                          </v-flex>
                          <v-flex  v-if="this.$route.query.islem == 'guncelle'" xs12 sm2 md1>
                            <v-text-field label="Süre" append-outer-icon="access_time" v-model="minute" ></v-text-field>
                          </v-flex>
                          </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-layout>
                    </v-form>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>
            <v-layout  v-if="this.$route.query.islem == 'guncelle'" row wrap>
              <v-flex pa-1 xs12 sm12 md12>
                <v-layout row wrap>
                <v-flex pa-1 xs12 sm12 md12>
                    <v-card class="white--text">
                      <v-card color="grey lighten-4" flat="">
                        <vue-editor placeholder="Sorun Açıklama" v-model="SorunEkle.SorunAciklama"></vue-editor>
                      </v-card>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
              <v-layout  v-if="this.$route.query.islem == 'yeni'" row wrap>
              <v-flex pa-1 xs12 sm12 md12>
                <v-layout row wrap>
                  
                  <v-flex pa-1 xs12 sm12 md6>
                    <v-card class="white--text">
                      <v-card color="grey lighten-4" flat="">
                        <vue-editor placeholder="Sorun Açıklama" v-model="SorunEkle.SorunAciklama"></vue-editor>
                      </v-card>
                    </v-card>
                  </v-flex>
                 
                  <v-flex pa-1 xs12 sm12 md6>
                    <v-card class="white--text">
                      <v-card color="grey lighten-4" flat="">
                        <vue-editor placeholder="Ücretli Destek Açıklama" v-model="SorunEkle.UcretliDestekAciklama"></vue-editor>
                      </v-card>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-layout>
      </v-form>
      <template>
        <v-card>
          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
          </v-snackbar>
        </v-card>
      </template>
    </v-card>
  </div>
</template>
<script>
  import auth from '../../../api/auth'
  import tarihim from '../customcomp/tarihim'
  import helpers from "@/components/app/customcomp/helpers.js"
  import { VueEditor } from "vue2-editor"
  export default {
    data() {
      time: ''              
      return {
        
        snackbar: false,
        timer:'',
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        kAdi: '',
        itemsSorunTip: [],
        saatHesaplaList:[],
        itemsBekledigiYer: [],
        itemsUrun: [],
        itemsUserBilgi: [],
        minute:'',
        itemMusteri: [],
        SorunEkle: {
          SorunID: null,
          MusteriBilgi: {
            MusteriID: null, // this.$route.query.musterikod,
            MusteriKod: null,
            MusteriAdi: null,
          },
          UserBilgi: {
            UserID: null,
            Email: null,
            AdSoyad: null,
          },
          AlisTarihi: null,
          Arayan: null,
          ArayanMail: null,
          CozecekBilgi: {
            UserID: null,
            Email: null,
            AdSoyad: null,
          },
          Cozuldu: null,
          UrunBilgi: {
            Ref: null,
            UrunAdi: null,
            UrunAciklama: null,
            Aciklama: null,
          },
          SorunAciklama: null,
          SorunTip: {
            SorunTipID: null,
            Aciklama: null,
          },
          BaslangicSaat: null,
          BitisSaat: null,
          BeklenenYer: {
            Id: null,
            ParentId: null,
            Aciklama: null,
            Yetki: null,
          },
          UcretliDestek: null,
          UcretliDestekAciklama: null,
        },


        baslik: '',

      }
    },
    
    methods: {

      ekle: ekle,
      guncelle: guncelle,
      problemTuru: problemTuru,
      isinBekledigiYer: isinBekledigiYer,
      urunBilgi: urunBilgi,
      userBilgileri: userBilgileri,
      //saatuygulamasi:saatuygulamasi,
      SaatBaslangic:SaatBaslangic,
      zeroPadding:zeroPadding,
      saatCanli:saatCanli,
      saatHesapla:saatHesapla,
    },
    beforeMount: beforeMount,

    components: {
      tarihim,
      VueEditor,
    },
     watch: {
       
     },
  }



    function saatCanli() {
      if(this.$route.query.islem == 'yeni'){
setInterval(() => {
    var cd = new Date();
    this.SorunEkle.BitisSaat = zeroPadding(cd.getHours(), 2) + ':' + zeroPadding(cd.getMinutes(), 2) + ':' + zeroPadding(cd.getSeconds(), 2);
}, 1000);}}

function SaatBaslangic() {
    var sb = new Date();
    this.SorunEkle.BaslangicSaat = zeroPadding(sb.getHours(), 2) + ':' + zeroPadding(sb.getMinutes(), 2) + ':' + zeroPadding(sb.getSeconds(), 2);
}

function zeroPadding(num, digit) {
    var zero = '';
    for(var i = 0; i < digit; i++) {
        zero += '0';
    }
    return (zero + num).slice(-digit);
}
        
         function saatHesapla(){
         var params = {
        ProblemID:  this.$route.query.sorunid
      }
      this.$http.post(auth.API_URL + 'api/ProblemsSupports/ProblemsLoad', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.saatHesaplaList  = response.body        
          var date1 = new Date(this.saatHesaplaList.BaslangicSaat)
          var date2 = new Date(this.saatHesaplaList.BitisSaat)
          var res = Math.abs(date1 - date2) / 1000
          var hours = Math.floor(res / 3600) % 24;    
          var last = Math.floor(res / 60) % 60
          var seconds = res % 60;
          if(last<9){
            this.minute = '0' + hours + ' : '  + '0' +last + ' : ' + seconds
          }else{
          this.minute = '0' + hours + ' : '  + last + ' : ' + seconds
          }
      }, (response) => {
        if (response.status === 0) {
          this.text1 = response.body.ResponseMessage
          this.snackbar = true
        } else {
          this.text1 = response.statusText
          this.snackbar = true
        }
      })
         }

  function beforeMount() {
    if (this.$route.query.islem == 'yeni') {
      this.baslik = 'Sorun Ekle'

    } else if (this.$route.query.islem == 'guncelle') {
      this.baslik = 'Sorun Güncelle'
      var params = {
        ProblemID: this.$route.query.sorunid
      }
      this.$http.post(auth.API_URL + 'api/ProblemsSupports/ProblemsLoad', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {

        this.SorunEkle = response.body
        this.SorunEkle.BaslangicSaat=this.SorunEkle.BaslangicSaat.substring(11,19)
        this.SorunEkle.BitisSaat=this.SorunEkle.BitisSaat.substring(11,19)


      }, (response) => {
        if (response.status === 0) {
          this.text1 = response.body.ResponseMessage
          this.snackbar = true
        } else {
          this.text1 = response.statusText
          this.snackbar = true
        }
      })
    }
    this.problemTuru()
    this.isinBekledigiYer()
    this.urunBilgi()
    this.userBilgileri()
    this.SaatBaslangic()
    this.saatCanli()
    this.saatHesapla()
  }  
  function guncelle() {

    var params = {

      SorunID: this.$route.query.sorunid,
      MusteriBilgi: {
        MusteriID: this.SorunEkle.MusteriBilgi.MusteriID,
        MusteriKod: this.SorunEkle.MusteriBilgi.MusteriKod,
        MusteriAdi: this.SorunEkle.MusteriBilgi.MusteriAdi,
      },
      UserBilgi: {
        UserID: this.SorunEkle.UserBilgi.UserID,
        Email: this.SorunEkle.UserBilgi.Email,
        AdSoyad: this.SorunEkle.UserBilgi.AdSoyad,
      },
      AlisTarihi: this.SorunEkle.AlisTarihi,
      Arayan: this.SorunEkle.Arayan,
      ArayanMail: this.SorunEkle.ArayanMail,
      CozecekBilgi: {
        UserID: this.SorunEkle.CozecekBilgi.UserID,
        Email: this.SorunEkle.CozecekBilgi.Email,
        AdSoyad: this.SorunEkle.CozecekBilgi.AdSoyad,
      },
      Cozuldu: this.SorunEkle.Cozuldu,
      UrunBilgi: {
        Ref: this.SorunEkle.UrunBilgi.Ref,
        UrunAdi: this.SorunEkle.UrunBilgi.UrunAdi,
        UrunAciklama: this.SorunEkle.UrunBilgi.UrunAciklama,
        Aciklama: this.SorunEkle.UrunBilgi.Aciklama,
      },
      SorunAciklama: this.SorunEkle.SorunAciklama,
      SorunTip: {
        SorunTipID: this.SorunEkle.SorunTip.SorunTipID,
        Aciklama: this.SorunEkle.SorunTip.Aciklama,
      },
      BaslangicSaat: this.SorunEkle.BaslangicSaat,
      BitisSaat: this.SorunEkle.BitisSaat,
      BeklenenYer: {
        Id: this.SorunEkle.BeklenenYer.Id,
        ParentId: this.SorunEkle.BeklenenYer.ParentId,
        Aciklama: this.SorunEkle.BeklenenYer.Aciklama,
        Yetki: this.SorunEkle.BeklenenYer.Yetki,
      },
      UcretliDestek: this.SorunEkle.UcretliDestek,
      UcretliDestekAciklama: this.SorunEkle.UcretliDestekAciklama,

    }


    this.$http.post(auth.API_URL + 'api/ProblemsSupports/ProblemsSave', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.text1 = response.body.ResponseMessage
      this.snackbar = true
            this.$router.push('/destek/sorundetay/id?' + 'sorunid=' + this.$route.query.sorunid)

    }, (response) => {
      if (response.Status === true) {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true
      } else {
        this.text1 = response.statusText
        this.snackbar = true
      }
    })
  }

  function ekle() {
    this.SorunEkle.MusteriBilgi.MusteriID= parseInt(this.$route.query.musterikod)

var params= this.SorunEkle


this.$http.post(auth.API_URL + 'api/ProblemsSupports/ProblemsSave', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.text1 = response.body.ResponseMessage
      this.snackbar = true
      this.$router.push('/destek/index/')
    }, (response) => {
      if (response.Status === true) {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true
      } else {
        this.text1 = response.statusText
        this.snackbar = true
      }
    })
  }

  function isinBekledigiYer() {
    this.$http.post(auth.API_URL + 'api/ProblemsSupports/ExpectedList', null, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.itemsBekledigiYer = response.body
    }, (response) => {
      if (response.Status === true) {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true
      } else {
        this.text1 = response.statusText
        this.snackbar = true
      }
    })
  }

  function userBilgileri() {
    var response = JSON.parse(window.localStorage.getItem('response'))
    var params = {

      Email: response.Email
    }
    this.$http.post(auth.API_URL + 'api/Register/WebUserList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.itemsUserBilgi = response.body
    }, (response) => {
      if (response.Status === true) {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true
      } else {
        this.text1 = response.statusText
        this.snackbar = true
      }
    })
  }

  function urunBilgi() {
    this.$http.post(auth.API_URL + 'api/Awed/AwedProductList', null, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.itemsUrun = response.body
    }, (response) => {
      if (response.Status === true) {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true
      } else {
        this.text1 = response.statusText
        this.snackbar = true
      }
    })
  }

  function problemTuru() {
    this.$http.post(auth.API_URL + 'api/ProblemsSupports/ProblemTypeList', null, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.itemsSorunTip = response.body
    }, (response) => {
      if (response.Status === true) {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true
      } else {
        this.text1 = response.statusText
        this.snackbar = true
      }
    })
  }


</script>
<style>
</style>